<h2 mat-dialog-title class="dialog-header">
    <span class="title-large">Aggiungi al carrello</span>

    <button
        mat-icon-button
        type="button"
        aria-label="Chiudi"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="content">
    <div class="selected-article-card">
        <span class="body-medium emphasized selected-article-label">Articolo selezionato:</span>

        <span class="body-medium emphasized selected-article-name">{{ data.nomeProdotto }}</span>

        <span class="body-medium">
            @if (data.sku) {
                {{ data.sku }}
            }
            @if (data.nomeImballo) {
                {{ data.nomeImballo }}
            }
        </span>

        <span class="body-medium">
            Prezzo unitario: {{ data.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}@if (data.unitaMisura) { / {{ data.unitaMisura }}}
        </span>

        <div class="quantity-stepper">
            @if (quantity() === 1) {
                <button
                    matButton="tonal"
                    aria-label="Annulla"
                    class="stepper-button"
                    (click)="onClose()"
                >
                    <i class="fa-regular fa-trash-can"></i>
                </button>
            } @else {
                <button
                    matButton="tonal"
                    aria-label="Diminuisci quantità"
                    class="stepper-button"
                    (click)="decrement()"
                >
                    <i class="fa-regular fa-minus"></i>
                </button>
            }

            <input
                class="body-medium emphasized quantity-value"
                type="number"
                min="1"
                aria-label="Quantità"
                [value]="quantity()"
                (change)="onQuantityInput($any($event.target).value)"
            />

            <button
                matButton="tonal"
                aria-label="Aumenta quantità"
                class="stepper-button"
                (click)="increment()"
            >
                <i class="fa-regular fa-plus"></i>
            </button>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton="filled" type="button" (click)="onConfirm()">Conferma e aggiungi</button>
</mat-dialog-actions>
